import LocalizedMessage from '../common/LocalizedMessage';
import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Input from "../common/Input";
import { STATUS } from "../common/Const";
import { email, mandatory, validateValues } from "../common/Validations";
import { hasNoErrors } from "../common/Helpers";
import * as userActions from "../../redux/actions/usersActions";
import VerificationRequired from "./VerificationRequired";
import { useTranslation } from 'react-i18next';

const validationConfig = {
  email: { label: "Email", validate: [mandatory, email] },
  password: { label: "Hasło", validate: [mandatory] },
  firstName: { label: "Imię", validate: [mandatory] },
  lastName: { label: "Nazwisko", validate: [mandatory] },
  mobile: { label: "Telefon", validate: [mandatory] },
};

export function SignupAccountPage({ signUpWithPassword }) {
  const { t: tr } = useTranslation();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    mobile: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(STATUS.IDLE);
  const [verificationEmail, setVerificationEmail] = useState("");

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateValues(formData, validationConfig);
    setErrors(validationErrors);
    if (!hasNoErrors(validationErrors)) {
      setStatus(STATUS.SUBMITTED);
      return;
    }

    setStatus(STATUS.SUBMITTING);
    signUpWithPassword(formData)
      .then((response) => {
        setVerificationEmail((response && response.email) || formData.email);
        setStatus(STATUS.COMPLETED);
      })
      .catch((error) => {
        setErrors({ saveError: error.message });
        setStatus(STATUS.SUBMITTED);
      });
  };

  if (status === STATUS.COMPLETED) {
    return (
      <div className="quiz-text account-signup-page">
        <VerificationRequired email={verificationEmail} />
      </div>
    );
  }

  return (
    <div className="quiz-text account-signup-page">
      <h2><strong>{tr("auth:signup")}</strong></h2>
      {errors.saveError && <div role="alert" className="alert alert-danger"><LocalizedMessage isError value={errors.saveError} /></div>}
      <form className="account-signup-form" onSubmit={handleSubmit}>
        {["email", "password", "firstName", "lastName", "mobile"].map(field => (
          <div className="form-row" key={field}>
            <div className="col-12">
              <Input
                label={validationConfig[field].label}
                type={field === "password" ? "password" : "text"}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                error={status === STATUS.SUBMITTED ? errors[field] : undefined}
                placeholder={validationConfig[field].label}
              />
            </div>
          </div>
        ))}
        <div className="row account-signup-actions">
          <div className="col-sm-8 col-md-6 col-lg-5">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={status === STATUS.SUBMITTING}>{tr("auth:signup")}</button>
          </div>
        </div>
      </form>
    </div>
  );
}

SignupAccountPage.propTypes = {
  signUpWithPassword: PropTypes.func.isRequired,
};

export default connect(null, {
  signUpWithPassword: userActions.signUpWithPassword,
})(SignupAccountPage);
